import type { SVGProps } from 'react'

export const ShoppingBagIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5534 16.4866L15.3409 6.48665C15.2567 6.10498 14.9184 5.83331 14.5276 5.83331H5.47258C5.08174 5.83331 4.74341 6.10498 4.65924 6.48665L2.44674 16.4866C2.33174 17.0066 2.72758 17.5 3.26008 17.5H16.7401C17.2726 17.5 17.6684 17.0066 17.5534 16.4866V16.4866Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.0835 5.83335V3.75002V3.75002V3.75002C12.0835 2.59919 11.151 1.66669 10.0002 1.66669H9.99935C8.84852 1.66669 7.91602 2.59919 7.91602 3.75002V3.75002V3.75002V5.83335"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M15.1334 6.11664L12.6167 17.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
